import {
	Text,
	Select,
	Upload,
	Number,
	TimeDuration,
	Textarea,
	CheckBox,
	FormGroupInterface,
	VALIDATION_TYPE,
	Radio,
	DDate,
	SimpleText
} from '../../types';
import * as moment from 'moment';

export interface ITCFormNotRequired {
	trainingCentreName: boolean
	geographicalLocation: boolean
	ownership: boolean
	franchiseDocuments: boolean
	duration: boolean
	centreCarpetArea: boolean
	totalCapacity: boolean
	totalNumberOfTrainingRooms: boolean
	totalNumberOfLabs: boolean
	numberOfMaleWashRooms: boolean
	numberOfFemaleWashRooms: boolean
	numberOfTransGenderWashRooms: boolean
	totalNumberOfTrainingRoomsPhotos: boolean
	totalNumberOfLabsPhotos: boolean
	numberOfMaleWashRoomsPhotos: boolean
	numberOfFemaleWashRoomsPhotos: boolean
	numberOfTransGenderWashRoomsPhotos: boolean
	distanceFromNearestAirport: boolean
	distanceFromNearestTrainStation: boolean
	distanceFromNearestCityCenter: boolean
}

export function getForm(data: any = {}, on: any = {}, notRequired: ITCFormNotRequired, mobile: any = {}, isSchemeIdGrameenUdhyami: Boolean = false, forJss?, isIndiaSkillsScheme?: any): FormGroupInterface {
	console.log('mobile', mobile, data);
	let onlineElements = [
		new Text('Training Application Name', {
			required: data.trainingCenterType === 'Online' ? true : false,
			showAstrisk: data.trainingCenterType === 'Online' ? true : false,
			placeholder: 'Enter Training Application name',
			name: 'trainingApplicationName',
			value: data.trainingApplicationName
		}),
		new Text('Training Application URL', {
			required: false,
			showAstrisk: false,
			placeholder: 'Enter Training Application URL',
			name: 'trainingApplicationURL',
			validationType: VALIDATION_TYPE.URL,
			value: data.trainingApplicationURL
		}),
	];
	let jssElement = [
		new Text('Training Centre Name', {
			required: data.trainingCenterType === 'Online' ? true : false,
			showAstrisk: data.trainingCenterType === 'Online' ? true : false,
			placeholder: 'Enter Training Centre name',
			name: 'trainingApplicationName',
			value: data.trainingApplicationName
		})
	];
	let facultyTypes = ['School', 'College', 'Corporate premises', 'Onsite', 'Others', 'E-Skill Training Centre'];
	if(forJss || data.trainingCenterType === 'JSS Sub Center'){
		facultyTypes.push('Jail Premises', 'Juvenile Center', 'Special Home')
	}
	if(forJss || data.trainingCenterType === 'JSS Sub Center'){
		facultyTypes.push('Training Centre')
	}
	const addingTCForm: FormGroupInterface = {
		label: 'Adding a Training Centre',
		backButton: true,
		// submitText: 'Submit',
		// cancelText: 'Cancel',
		forms: [
			{
				label: 'Training Centre Details',
				hide: (data.trainingCenterType !== 'Online' && data.trainingCenterType !== 'JSS Sub Center'),
				formElements: (forJss || data.trainingCenterType === 'JSS Sub Center') ? jssElement : onlineElements
				// [
				// 	new Text('Training Application Name', {
				// 		required: data.trainingCenterType === 'Online' ? true : false,
				// 		showAstrisk: data.trainingCenterType === 'Online' ? true : false,
				// 		placeholder: 'Enter Training Application name',
				// 		name: 'trainingApplicationName',
				// 		value: data.trainingApplicationName
				// 	}),
				// 	new Text('Training Application URL', {
				// 		required: false,
				// 		showAstrisk: false,
				// 		placeholder: 'Enter Training Application URL',
				// 		name: 'trainingApplicationURL',
				// 		validationType: VALIDATION_TYPE.URL,
				// 		value: data.trainingApplicationURL
				// 	}),
				// ]
			},
			{
				label: 'Training Centre Info:',
				// name: 'info',
				formElements: [
					new Text((forJss || data.trainingCenterType === 'JSS Sub Center') ? 'Training Centre Type' : 'Training Centre Name', {
						required: notRequired && !notRequired.trainingCentreName,
						showAstrisk: true,
						placeholder: 'Enter full name',
						validationType: VALIDATION_TYPE.TC_NAME,
						// metainfo: 'Please enter Training Centre full name',
						name: 'trainingCentreName',
						value: forJss ? 'JSS Sub Center' : data.trainingCenterType === 'Online' ? "Online Training Center" : data.trainingCentreName
					}),
					new Radio('Geographical Location', [
						{
							name: 'Rural Location',
							value: 'ruralLocation'
						},
						{
							name: 'Urban Location',
							value: 'urbanLocation'
						}
					], {
						required: notRequired && !notRequired.geographicalLocation,
						showAstrisk: true,
						name: 'geographicalLocation',
						value: data.geographicalLocation,
					}),
					new Select(
						'Centre Ownership',
						['Self Run', 'Franchise'],
						// data.centreOwnershipOptions,
						{
							required: notRequired && !notRequired.ownership,
							showAstrisk: notRequired && !notRequired.ownership,
							name: 'ownership',
							align: 12,
							placeholder: 'Select Training Centre ownership',
							value: data.ownership,
							onChange: on.centreOwnershipChange,
						}
					),
					new Select(
						'Type',
						['Rented', 'Owned'],
						{
							required: true,
							showAstrisk: true,
							name: 'typeOfTC',
							align: 12,
							hide: false,
							placeholder: 'Select Type',
							value: data && data.typeOfTC,
							asyncLoad: true,
							// onChange: on.centreOwnershipChange,
						}
					),
					new Select(
						'Centre Faculty Type',
						// ['School', 'College', 'Corporate premises', 'Onsite', 'Others', 'E-Skill Training Centre'],
						facultyTypes,
						{
							required: true,
							showAstrisk: true,
							name: 'centerOwnershipType',
							align: 12,
							hide: false,
							placeholder: 'Select Center Faculty Type',
							value: (forJss || data.trainingCenterType === 'JSS Sub Center') ? 'Training Centre' : data.trainingCenterType === 'Online' ? "E-Skill Training Centre" : data.facultyType || data.centerOwnershipType,
							// onChange: on.centreOwnershipChange,
						}
					),
					new Upload('Franchise Documents:', {
						// required: true,
						multi: true,
						allowedFormats: ['pdf', 'jpeg', 'png', 'jpg'],
						name: 'franchiseDocuments',
						required: notRequired && !notRequired.franchiseDocuments,
						showAstrisk: notRequired && !notRequired.franchiseDocuments,
						// maxFiles: 3,
						hide: false,
						value: (data && data.franchiseDocuments),
					}),
					new SimpleText(
						'Training Centre Creation Date',
						{
							name: 'startDate',
							showAstrisk: true,
							placeholder: 'Select Effective Date',
							// id: 'fullDate',
							type: 'date',
							disabled: true,
							value: data.createdOn && data.createdOn ? data.createdOn : new Date().toISOString()
						},

						// 'Training Centre Duration',
						// [
						// 	{
						// 		name: 'startDate',
						// 		placeholder: 'Select Effective Date',
						// 		id: 'fullDate',
						// 		value: data.duration && data.duration.startDate
						// 	},
						// 	{
						// 		name: 'endDate',
						// 		placeholder: 'Select Close Date',
						// 		id: 'fullDate1',
						// 		value: data.duration && data.duration.endDate,
						// 	}
						// ],
						// {
						// 	required: notRequired && !notRequired.duration,
						// 	name: 'duration',
						// 	maxTenureInYears: 20,
						// 	disableNotAllowed: true,
						// 	toDateRequired: false,
						// 	minStartDate: new Date(1900, 0, 1),
						// 	maxStartDate: (() => {
						// 		const maxStartDate = new Date();
						// 		maxStartDate.setFullYear(maxStartDate.getFullYear() + 1);
						// 		return maxStartDate;
						// 	})(),
						// 	validationType: VALIDATION_TYPE.DATE_DURATION
						// }
					),
					new SimpleText(
						'Training Centre Last Updated Date',
						{
							name: 'updatedDate',
							showAstrisk: false,
							placeholder: 'Select Effective Date',
							// id: 'fullDate',
							type: 'date',
							disabled: true,
							value: data.modifiedOn && data.modifiedOn ? getDateFormat(data.modifiedOn) : 'N/A'
						},
					),
					// -------------------------> Optional fields mibile and fixed
					new Number('Centre Area(In Sq.Ft)', {
						required: mobile.temporary === true || data.trainingCenterType === 'Online' ? false : true,
						showAstrisk: mobile.temporary === true || data.trainingCenterType === 'Online' ? false : true,
						name: 'centreCarpetArea',
						placeholder: 'Enter Centre area in square feet',
						validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
						hide: false,
						align: 6,
						min: 50,
						// max: 99999999,
						maxFieldLength: 5,
						value:
							data.residentialFacilities &&
							data.residentialFacilities.centreCarpetArea,
						onChange: on.centreAreaChange,
					}),
				]
			}, {
				hide: (data.trainingCenterType === 'Online' || data.trainingCenterType === 'JSS Sub Center' || data.schemeId === 'Scheme_1284' || !data.isIndiaSkillsScheme ),
				label: 'Infrastructure Details:',
				formElements: [
					// -------------------------> Optional fields mibile and fixed
					new SimpleText('Candidate-wise Centre Capacity:', {
						required: (notRequired && !notRequired.totalCapacity && mobile.temporary === true) || data.trainingCenterType === 'Online' ? false : true,
						showAstrisk: (true && mobile.temporary === true) || data.trainingCenterType === 'Online' ? false : true,
						validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
						align: 12,
						placeholder: 'Enter the Centre Capacity',
						name: 'totalCapacity',
						value:
							data.residentialFacilities &&
							data.residentialFacilities.totalCapacity,
						maxFieldLength: 4,
						// max: 999999
					}),
					// -------------------------> Optional fields mibile and fixed
					new Select('Number of Training Rooms',
						getCountOptions(99),
						{
							required: isSchemeIdGrameenUdhyami || data.trainingCenterType === 'Online' ? false : true,
							showAstrisk: isSchemeIdGrameenUdhyami || data.trainingCenterType === 'Online' ? false : true,

							align: 6,
							name: 'totalNumberOfTrainingRooms',
							value:
								data.residentialFacilities &&
								data.residentialFacilities
									.totalNumberOfTrainingRooms,
							onChange: on.onTrainingRoomPhotosCategoryChange,
						},

					),
					new Select('Number of Labs',
						getCountOptionsWithZero(15), {
						required: mobile.temporary === true || data.trainingCenterType === 'Online' || isSchemeIdGrameenUdhyami ? false : true,
						showAstrisk: mobile.temporary === true || data.trainingCenterType === 'Online' || isSchemeIdGrameenUdhyami ? false : true,
						validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
						align: 6,
						name: 'totalNumberOfLabs',
						onChange: on.onLaboratoryRoomCountChange,
						value:
							data.residentialFacilities &&
							data.residentialFacilities.totalNumberOfLabs
					}
					),
					new Select('Number of Male Washroom',
						getWashroomOptions(),
						{
							required: mobile.temporary === true || data.trainingCenterType === 'Online' || isSchemeIdGrameenUdhyami ? false : true,
							showAstrisk: mobile.temporary === true || data.trainingCenterType === 'Online' || isSchemeIdGrameenUdhyami ? false : true,
							align: 6,
							name: 'numberOfMaleWashRooms',
							value: data.numberOfMaleWashRooms,
							onChange: on.onMaleWashroomCountChange,
						}),
					new Select('Number of Female Washroom',
						getWashroomOptions(),
						{
							required: mobile.temporary === true || data.trainingCenterType === 'Online' || isSchemeIdGrameenUdhyami ? false : true,
							showAstrisk: mobile.temporary === true || data.trainingCenterType === 'Online' || isSchemeIdGrameenUdhyami ? false : true,
							align: 6,
							name: 'numberOfFemaleWashRooms',
							value: data.numberOfFemaleWashRooms,
							onChange: on.onFemalWashroomCountChange,
						}),
					new Select('Number of Unisex Washroom',
						getWashroomOptions(),
						{
							required: mobile.temporary === true || data.trainingCenterType === 'Online' || isSchemeIdGrameenUdhyami ? false : true,
							showAstrisk: mobile.temporary === true || data.trainingCenterType === 'Online' || isSchemeIdGrameenUdhyami ? false : true,
							align: 6,
							name: 'numberOfTransGenderWashRooms',
							value: data.numberOfTransGenderWashRooms,
							onChange: on.onUnisexWashroomCountChange,
						}),
					new SimpleText('Total Number of Washroom',
						{
							align: 6,
							name: 'totalNumberOfWashroom',
							showAstrisk: mobile.temporary === true || data.trainingCenterType === 'Online' || isSchemeIdGrameenUdhyami ? false : true,
							disabled: mobile.temporary === true || data.trainingCenterType === 'Online' || isSchemeIdGrameenUdhyami ? false : true,
							value: data.totalNumberOfWashroom,
							onChange: on.onTotalNumberOfWashroomChange,
						}),
					// -------------------------> Optional fields mibile and fixed
					new Text('Distance from Nearest airport(in Kms)', {
						required: mobile.temporary || data.trainingCenterType === 'Online' || isSchemeIdGrameenUdhyami ? false : true,
						name: 'distanceFromNearestAirport',
						placeholder: 'Enter distance in Kms',
						validationType: VALIDATION_TYPE.DECIMAL_NUMBER,
						hide: mobile.temporary ? true : false,
						charAllowedPattern: '[0-9.]',
						align: 6,
						maxFieldLength: 6,
						min: 0,
						max: 999,
						value: data.distanceFromNearestAirport
					}),
					new Text('Distance from Nearest Train Station(in Kms)', {
						required: mobile.temporary || data.trainingCenterType === 'Online' || isSchemeIdGrameenUdhyami ? false : true,
						name: 'distanceFromNearestTrainStation',
						placeholder: 'Enter distance in Kms',
						validationType: VALIDATION_TYPE.DECIMAL_NUMBER,
						hide: mobile.temporary ? true : false,
						charAllowedPattern: '[0-9.]',
						align: 6,
						maxFieldLength: 6,
						min: 0,
						max: 999,
						value: data.distanceFromNearestTrainStation
					}),
					new Text('Distance from City Center(in Kms)', {
						required: mobile.temporary || data.trainingCenterType === 'Online' || isSchemeIdGrameenUdhyami ? false : true,
						name: 'distanceFromNearestCityCenter',
						placeholder: 'Enter distance in Kms',
						validationType: VALIDATION_TYPE.DECIMAL_NUMBER,
						hide: mobile.temporary ? true : false,
						charAllowedPattern: '[0-9.]',
						align: 6,
						maxFieldLength: 6,
						min: 0,
						max: 999,
						value: data.distanceFromNearestCityCenter
					})
				]
			}
		]
	};
	return addingTCForm;
}

export function getSpocContactInfo(
	data: any = {},
	on: any = {},
	notRequired: ITCFormNotRequired,
): FormGroupInterface {
	console.log(data, 'data');
	const spocForm: FormGroupInterface = {
		label: '',
		forms: [
			{
				label: 'Single Point of Contact Info',
				name: 'spoc',
				formElements: [
					new Text('Name of The SPOC', {
						required: true,
						showAstrisk: true,
						validationType: VALIDATION_TYPE.NAME,
						name: 'firstName',
						value: data.spoc && data.spoc.firstName
					}),
					new Text('Email Address', {
						required: true,
						showAstrisk: true,
						// validationType: VALIDATION_TYPE.EMAIL,
						pattern: '^[_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$',
						name: 'email',
						value: data.spoc && data.spoc.email
					}),
					new Text('Mobile Number', {
						required: true,
						showAstrisk: true,
						validationType: VALIDATION_TYPE.MOBILE_NUMBER,
						value: data.spoc && data.spoc.mobileNumber
					}),
					new Text('Designation', {
						required: true,
						showAstrisk: true,
						validationType: VALIDATION_TYPE.DESIGNATION,
						name: 'centreSPOCDesignation',
						value: data.spoc && data.spoc.centreSPOCDesignation
					}),
					new Text('Landline Number(with STD Code):', {
						required: false,
						name: 'landline',
						charAllowedPattern: '[0-9]',
						validationType: VALIDATION_TYPE.LANDLINE_NUMBER,
						value: data.spoc && data.spoc.landline
					})
				]
			},
			// {
			// 	name: 'photos',
			// 	formElements: [
			// 		new Upload('Training Room Photos:', {
			// 			required: notRequired && !notRequired.totalNumberOfTrainingRoomsPhotos,
			// 			showAstrisk: true,
			// 			uploadType: UPLOAD_TYPE.CATEGORISED,
			// 			categories: data.trainingCentreCategories,
			// 			multi: true,
			// 			isCategorised: true,
			// 			hide: true,
			// 			allowedFormats: ['jpeg', 'png', 'jpg'],
			// 			name: 'trainingRoomPhotos',
			// 			value: data.photos && data.photos.trainingRoomPhotos,
			// 		}),
			// 		new Upload('Laboratory Room Photos:', {
			// 			required: notRequired && !notRequired.totalNumberOfLabsPhotos,
			// 			showAstrisk: true,
			// 			uploadType: UPLOAD_TYPE.CATEGORISED,
			// 			categories: data.laboratoryRoomCategories,
			// 			multi: true,
			// 			isCategorised: true,
			// 			hide: true,
			// 			allowedFormats: ['jpeg', 'png', 'jpg'],
			// 			name: 'laboratoryRoomPhotos',
			// 			value: data.photos && data.photos.laboratoryRoomPhotos
			// 		}),
			// 		new Upload('Male Washroom Photos:', {
			// 			required: notRequired && !notRequired.numberOfMaleWashRoomsPhotos,
			// 			showAstrisk: true,
			// 			uploadType: UPLOAD_TYPE.CATEGORISED,
			// 			categories: data.maleCategories,
			// 			multi: true,
			// 			isCategorised: true,
			// 			maxSize: 5,
			// 			hide: true,
			// 			allowedFormats: ['jpeg', 'png', 'jpg'],
			// 			name: 'maleWashroomRoomPhotos',
			// 			value: data.photos && data.photos.maleWashroomRoomPhotos
			// 		}),
			// 		new Upload('Female Washroom Photos:', {
			// 			required: notRequired && !notRequired.numberOfFemaleWashRoomsPhotos,
			// 			showAstrisk: true,
			// 			uploadType: UPLOAD_TYPE.CATEGORISED,
			// 			categories: data.femaleCategories,
			// 			multi: true,
			// 			isCategorised: true,
			// 			maxSize: 5,
			// 			hide: true,
			// 			allowedFormats: ['jpeg', 'png', 'jpg'],
			// 			name: 'femaleWashroomRoomPhotos',
			// 			value: data.photos && data.photos.femaleWashroomRoomPhotos
			// 		}),
			// 		new Upload('Unisex Washroom Photos:', {
			// 			required: notRequired && !notRequired.numberOfTransGenderWashRoomsPhotos,
			// 			showAstrisk: true,
			// 			uploadType: UPLOAD_TYPE.CATEGORISED,
			// 			categories: data.UnisexCategories,
			// 			multi: true,
			// 			isCategorised: true,
			// 			maxSize: 5,
			// 			hide: true,
			// 			allowedFormats: ['jpeg', 'png', 'jpg'],
			// 			name: 'unisexWashroomRoomPhotos',
			// 			value: data.photos && data.photos.unisexWashroomRoomPhotos
			// 		}),
			// 	]
			// }
		]
	};
	return spocForm;
}


function getWashroomOptions() {
	return getCountOptionsFromZero(15)
}

function getCountOptions(till) {
	const options = [];
	for (let i = 1; i <= till; i++) {
		options.push(i);
	}
	return options;
}

function getCountOptionsWithZero(till) {
	const options = [];
	for (let i = 0; i <= till; i++) {
		options.push(i);
	}
	return options;
}

function getCountOptionsFromZero(till) {
	const options = [];
	for (let i = 0; i <= till; i++) {
		options.push(i);
	}
	return options;
}

function getDateFormat(date) {
	return date ? moment(date).format('DD/MM/YYYY') : 'N/A'
}
